/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLineMemoryUploadVoiceRequest
 */
export interface PostLineMemoryUploadVoiceRequest {
    /**
     * 
     * @type {string}
     * @memberof PostLineMemoryUploadVoiceRequest
     */
    filePath: string;
    /**
     * 
     * @type {string}
     * @memberof PostLineMemoryUploadVoiceRequest
     */
    memoryId: string;
}

/**
 * Check if a given object implements the PostLineMemoryUploadVoiceRequest interface.
 */
export function instanceOfPostLineMemoryUploadVoiceRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "filePath" in value;
    isInstance = isInstance && "memoryId" in value;

    return isInstance;
}

export function PostLineMemoryUploadVoiceRequestFromJSON(json: any): PostLineMemoryUploadVoiceRequest {
    return PostLineMemoryUploadVoiceRequestFromJSONTyped(json, false);
}

export function PostLineMemoryUploadVoiceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLineMemoryUploadVoiceRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filePath': json['filePath'],
        'memoryId': json['memoryId'],
    };
}

export function PostLineMemoryUploadVoiceRequestToJSON(value?: PostLineMemoryUploadVoiceRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filePath': value.filePath,
        'memoryId': value.memoryId,
    };
}

